import { render, staticRenderFns } from "./AccountPasswordRemind.vue?vue&type=template&id=4b6fcbd8"
import script from "./AccountPasswordRemind?vue&type=script&lang=ts&external"
export * from "./AccountPasswordRemind?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports